import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router';
import { unauthHeaders, refresh } from '../../utils/API';
import Auth from './Auth';
import { ErrorAlert } from '../../utils/Alerts';

const AuthContainer = () => {
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(false);
    const [phone, setPhone] = useState(sessionStorage.getItem('forgot_userName'));
    const [password, setPassword] = useState('');
    const [isShowPassword, setIsShowPassword] = useState(false);
    const [isRememberMe, setIsRememberMe] = useState(false);

    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState();

    const onClickAuth = () => {
        // sessionStorage.removeItem('forgot_userName');
        if (!phone || !password) {
            setIsError(true);
            setErrorMessage("Заполните все обязательные поля");
            return
        }
        const re = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[_!@#\$%\^&\*\\?])(?=.{8,})");
        // "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\\?])(?=.{8,})"
        const isOk = re.test(password);
        // if (!isOk) {
        //     setErrorMessage("В пароле должны быть строчные латинские буквы, заглавные латинские буквы, знаки синтаксиса, длина пароля должна быть не менее восьми символов");
        //     return
        // }
        setIsLoading(true);
        axios.post(`${process.env.REACT_APP_API}api/v1.0/auth/token`, {
            UserName: parseInt(phone.replace(/\D+/g, "")),
            Password: password,
        }, {
            headers: unauthHeaders
        })
            .then((res) => {
                setIsLoading(false);
                sessionStorage.setItem('token', res.data.token);
                sessionStorage.setItem('refreshToken', res.data.refreshToken);
                if (isRememberMe) {
                    localStorage.setItem('refreshToken', res.data.refreshToken);
                }
                history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk`);
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response && err.response.data.message);
                setIsLoading(false);
                sessionStorage.setItem('forgot_userName', phone);
            });
    }

    const onChangePhone = (e) => {
      setPhone(e);
      sessionStorage.setItem('forgot_userName', e);
    }

    return (
        <>
            <Auth
                isLoading={isLoading}
                phone={phone}
                setPhone={onChangePhone}
                password={password}
                setPassword={setPassword}
                isShowPassword={isShowPassword}
                setIsShowPassword={setIsShowPassword}
                isRememberMe={isRememberMe}
                setIsRememberMe={setIsRememberMe}

                isError={isError}

                onClickAuth={onClickAuth}
                errorMessage={errorMessage}
            />
        </>
    )
}

export default AuthContainer;
